import { render, staticRenderFns } from "./orderconfirm.vue?vue&type=template&id=80e45470&scoped=true"
import script from "./orderconfirm.vue?vue&type=script&lang=ts"
export * from "./orderconfirm.vue?vue&type=script&lang=ts"
import style0 from "./orderconfirm.vue?vue&type=style&index=0&id=80e45470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e45470",
  null
  
)

export default component.exports